<div class="row">
  <div class="col-lg-3 offset-lg-9 addpayorinfo">
    <button class="btn blue-btn btn-sm" [disabled]="global.viewTabs"
      (click)="editPayorRequiredId('new','00000000-0000-0000-0000-000000000000')" *ngIf="fp.payorrequiredcreate">Add
      Payor
      Info</button>
  </div>
</div>
<ejs-grid #grid [dataSource]='data |async' [allowResizing]='true' [allowSorting]='true' allowPaging='true'
  [allowFiltering]='true' [pageSettings]='initialPage' [filterSettings]='filterOptions' (actionBegin)="onActionComplete($event)" (dataStateChange)='dataStateChange($event)'>
  <e-columns>
    <e-column minWidth=100 headerText="Actions" uid="action" textAlign='center'>
      <ng-template #template let-data>
        <button class="btn btn-edit-table" (click)="editPayorRequiredId('edit',data)" [disabled]="global.viewTabs"
          *ngIf="fp.payorrequiredupdate"><i class="fa fa-edit"></i></button>
        <button data-bs-target="#deletepayor" data-bs-toggle="modal" class=" btn btn-delete-table deletebtnpad ms-2"
          [disabled]="global.viewTabs" (click)="setDeleteId(data.id)" *ngIf="fp.payorrequireddelete">
          <i class="fa fa-trash fa-lg"></i></button>
      </ng-template>
    </e-column>
    <e-column minWidth=100 field="payorName" headerText="Payors" type="string">
      <ng-template #filterTemplate let-data>
        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
      </ng-template>
    </e-column>
    <e-column minWidth=100 field="billingPayerRequiredId" headerText="ID Number" type="string">
      <ng-template #filterTemplate let-data>
        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
      </ng-template>
    </e-column>

    <e-column minWidth=100 field="startDate" headerText="Start Date" type="date" [format]='formatOptions'
      [allowFiltering]='false'></e-column>
    <e-column minWidth=100 field="endDate" headerText="End Date" type="date" [format]='formatOptions'
      [allowFiltering]='false'></e-column>
    <ng-template #filterTemplate let-data>
      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
    </ng-template>

  </e-columns>
</ejs-grid>


<span id="deletemodal" data-bs-toggle="modal" data-bs-target="#deletepayor"></span>
<div class="modal fade modalbackgrod" id="deletepayor" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="false">
  <div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
      </div>
      <div class="modal-body">
        Do you want to delete this record ?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" (click)="deletepayor()">Yes</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>

  


  <ejs-grid #grid [dataSource]='data |async' [allowResizing]='true' [allowSorting]='true' allowPaging='true'
    [allowFiltering]='true' [pageSettings]='initialPage' 
    [filterSettings]='filterOptions'  [showColumnChooser]='true' (dataStateChange)="dataStateChange($event)" 
    (actionBegin)="onActionComplete($event)"
    >
    <e-columns>
      <e-column minWidth=100 headerText="Actions" uid="action" textAlign='center' [allowFiltering]="false" [allowSorting]="false">
        <ng-template #template let-data>
          <button  class="btn btn-edit-table"
            (click)="editPayorRequiredId('edit',data)" [disabled]="global.viewTabs"  *ngIf="fp.payorrequiredupdate"><i class="fa fa-edit"></i></button>
          <button  data-bs-target="#deletepayor" data-bs-toggle="modal"
            class=" btn btn-delete-table deletebtnpad ms-2" [disabled]="global.viewTabs" (click)="setDeleteId(data.id)"
            *ngIf="fp.payorrequireddelete" >
            <i class="fa fa-trash fa-lg"></i></button>
        </ng-template>
      </e-column>
      <e-column minWidth=100 field="payorName" headerText="Payors" type="string">
        <ng-template #filterTemplate let-data>
          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
        </ng-template>
      </e-column>
      <e-column minWidth=100 field="billingPayerRequiredId" headerText="ID Number" type="string"> 
        <ng-template #filterTemplate let-data>
          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
        </ng-template>
      </e-column>
  
      <e-column minWidth=100 field="startDate" headerText="Start Date" type="date" [format]='formatOptions' [allowFiltering]="false"></e-column>
      <e-column minWidth=100 field="endDate" headerText="End Date" type="date" [format]='formatOptions' [allowFiltering]="false"></e-column>
        <!-- <ng-template #filterTemplate let-data>
          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
        </ng-template> -->
  
    </e-columns>
  </ejs-grid>
  
 
  <span id="deletemodal" data-bs-toggle="modal" data-bs-target="#deletepayor"></span>
  <div class="modal fade modalbackgrod" id="deletepayor" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true" data-bs-backdrop="false">
      <div class="modal-dialog create-update-zip" role="document">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
              </div>
              <div class="modal-body">
                  Do you want to delete this record ?
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"  (click)="deletepayor()"
                     >Yes</button>
                  <button  type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" >No</button>
              </div>
          </div>
      </div>
  </div>

